import keyBy from 'lodash/keyBy';

import CheckBoxField from '@/modules/corporate/modules/database/fields/checkbox';
import DateField from '@/modules/corporate/modules/database/fields/date';
import MultiSelectField from '@/modules/corporate/modules/database/fields/multiSelect';
import NumberField from '@/modules/corporate/modules/database/fields/number';
import RatingField from '@/modules/corporate/modules/database/fields/rating';
import SelectField from '@/modules/corporate/modules/database/fields/select';
import TextField from '@/modules/corporate/modules/database/fields/text';

export const ALL_FIELDS = [
  TextField,
  NumberField,
  CheckBoxField,
  DateField,
  SelectField,
  MultiSelectField,
  RatingField,
];

const Fields = keyBy(ALL_FIELDS, 'type');

export default Fields;
